import React from "react";
import { ServerConfig } from "../../api/Types";

export interface IConfigContext {
  isFeatureEnabled: (featureName: string) => boolean;
  getFeatureConfig: (featureName: string) => any;
  getFeatureConfigValue: <T>(featureName: string, configValueName: string) => T;
  config: ServerConfig | null;
  // isLoading: boolean;
  // error?: Error;
}

export const ConfigContext = React.createContext<IConfigContext | null>(null);

export const useConfig = (): IConfigContext => React.useContext(ConfigContext) as IConfigContext;
